'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/fbjs/~/promise/index.js
// module id = 1302
// module chunks = 0